/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCrop75 = createReactComponent("crop-7-5", "IconCrop75", [
  [
    "path",
    {
      d: "M4 6m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ]
]);

export { IconCrop75 as default };
//# sourceMappingURL=IconCrop75.js.map
